import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { ExpressionOfInterestForm } from '../../forms';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import { TopbarContainer } from '..';

import {
  Page,
  LayoutSideNavigation,
  LayoutWrapperMain,
  LayoutWrapperSideNav,
  LayoutWrapperTopbar,
  LayoutWrapperFooter,
  JoinUsContent,
  Footer,
} from '../../components';
import config from '../../config';


import hiFive from './hi5.png';
import css from './JoinUsPage.module.css';

const JoinUsPageComponent = props => {
  const { scrollingDisabled, intl } = props;
  const [expressionSent, setExpressionSent] = useState(null);

  const handleSubmit = result => {
    setExpressionSent(result.success);
  };

  const tabs = [
    {
      text: intl.formatMessage({ id: 'JoinUsPage.joinusTabTitle' }),
      selected: true,
      linkProps: {
        name: 'JoinUsPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'CommProfJoinPage.commprofTabTitle' }),
      selected: false,
      linkProps: {
        name: 'CommProfJoinPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'DeafCommJoinPage.deafcommTabTitle' }),
      selected: false,
      linkProps: {
        name: 'DeafCommJoinPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'InvestorsJoinPage.investorsTabTitle' }),
      selected: false,
      linkProps: {
        name: 'InvestorsJoinPage',
      },
    },
  ];
  const siteTitle = config.siteTitle;
  const schemaTitle = intl.formatMessage({ id: 'JoinUsPage.schemaTitle' }, { siteTitle });
  const schema = {
    '@context': 'http://schema.org',
    '@type': 'WebPage',
    name: schemaTitle,
  };
  return (
    <Page title={schemaTitle} scrollingDisabled={scrollingDisabled} schema={schema}>
      <LayoutSideNavigation>
        <LayoutWrapperTopbar>
          <TopbarContainer currentPage="JoinUsPage" />
        </LayoutWrapperTopbar>
        <LayoutWrapperSideNav tabs={tabs} />
        <LayoutWrapperMain>
          <div className={css.content}>
            <h1 className={css.heading}>
              <FormattedMessage id="JoinUsPage.heading" />
            </h1>
            <JoinUsContent />
            <ExpressionOfInterestForm
              expressionSent={expressionSent}
              formId="ExpressionOfInterestForm"
              onSubmit={handleSubmit}
            />
            <img src={ hiFive } alt="Signalise hands happy" className={ css.hiFive }/>
          </div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSideNavigation>
    </Page>
  );
};

const { bool } = PropTypes;

JoinUsPageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const JoinUsPage = compose(connect(mapStateToProps), injectIntl)(JoinUsPageComponent);

export default JoinUsPage;
